import { Component, inject, input, model, signal } from '@angular/core';
import { MaterialIconComponent, ToastService } from '@ps-gui/shared-core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'shared-ui-upload',
  templateUrl: './upload.component.html',
  imports: [MaterialIconComponent, NgClass],
})
export class UploadComponent {
  readonly title = input('');
  readonly file = model.required<File | undefined>();

  private readonly ALLOWED_MIME_TYPE = 'application/pdf';
  private readonly sevenMegaBytes: number = 7 * 1024 * 1024;

  private readonly toastService = inject(ToastService);

  onDropFile(event: DragEvent): void {
    this.preventDefaultAndStopPropagation(event);
    const file: File | undefined = event.dataTransfer?.files[0];
    this.validateAndSetFile(file);
  }

  addFile(event: any): void {
    const file = event.target.files[0];
    this.validateAndSetFile(file);
  }

  deleteFile(): void {
    this.file.set(undefined);
  }

  private validateAndSetFile(file?: File): void {
    if (!file || !this.isFileValid(file)) {
      this.toastService.addErrorToast(
        'Es werden nur PDF-Dateien mit der Maximalgröße von 7 MB akzeptiert.',
      );
      this.valid.set(false);

      return;
    }

    this.file.set(file);
    this.valid.set(true);
  }

  private isFileValid(file: File): boolean {
    return this.ALLOWED_MIME_TYPE == file.type && file.size <= this.sevenMegaBytes;
  }

  readonly valid = signal(true);

  preventDefaultAndStopPropagation(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
